<template>
  <div class="app-container">
    <BjPage ref="BjPage" :auto-fetch="false" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :selection="selection" :before-reset-search="beforeResetSearch" :before-query-search="beforeQuerySearch" res="page" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- <template>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockSearch.header.warehouseCode')" prop="warehouseCode">
              <BjInput
                v-model="queryParams.warehouseCode"
                :maxlength="MAX_LENGTH.DEFAULT"
                :placeholder="$t('BusinessStockSearch.header.warehouseCode')"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockSearch.header.warehouseId')" prop="warehouseTypeCodeList">
              <BjSelectLov v-model="queryParams.warehouseTypeCodeList" :option-list="WarehousesList" :placeholder="$t('BusinessStockSearch.header.warehouseId')" multiple />
            </el-form-item>
          </el-col>
        </template> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.table.skuCode')" prop="skuCode">
            <BjInput
              v-model="queryParams.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockChange.table.skuCode')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.order')">
            <BjDateRangePicker v-model="queryParamsTime" :placeholder="$t('BusinessStockChange.table.creationDate')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjFrontendExport
            type="primary"
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Inventory Transaction.csv"
            translate-label
          />
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onView(scope.row)">
                {{ scope.row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">
                {{ $t(STOCK_LOCK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.status !== 'success'" type="text" @click="onStatus('close', scope.row)">{{ $t('disableText') }}</el-button>
              <el-button :disabled="scope.row.status !== 'close'" type="text" @click="onStatus('wait', scope.row)">{{ $t('enableText') }}</el-button>
              <el-button :disabled="scope.row.status !== 'wait'" type="text" @click="onStatus('abandon', scope.row)">{{ $t('BusinessStockChange.voidBtn') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import { STOCK_LOCK_STATUS_LIST } from '@/utils/constants';
import moment from 'moment';
export default {
  name: 'BusinessStockChangeCSG',
  mixins: [pageMiXin],

  data() {
    return {
      colSpan: 4,
      selection: true,
      STOCK_LOCK_STATUS_LIST,
      queryApi: stockApi.getChangeRecords,
      // 查询参数
      queryParams: {
        skuCode: null,
        warehouseCode: null,
        qtyTypeCode: 'usableNum',
        warehouseTypeCodeList: ['channel'],
        beginDate: moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      labelList: [
        { label: 'BusinessStockChange.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 160},
        // { label: 'BjDialogListConfig.SKUname', prop: 'skuName', isCheck: true, disabled: false, width: 160},
        { label: 'BusinessStockSearch.table.changeNum', prop: 'changeNum', isCheck: true, disabled: false },
        { label: 'BusinessStockChange.table.recordCode', prop: 'recordCode', isCheck: true, disabled: false },
        { label: 'BusinessStockChange.table.creationDate', prop: 'creationDate', isCheck: true, disabled: false, export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
        { label: 'BusinessStockChange.table.warehouseCode', prop: 'warehouseCode', isCheck: true, disabled: false, width: 160},
        { label: 'BusinessStockChange.table.warehouseName', prop: 'warehouseName', isCheck: true, disabled: false, width: 160},
      ],
      queryParamsTime: null,
      totalData: {},
      // WarehousesList: [],
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.beginDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    },
  },
  mounted() {
    // this.getList();
  },
  methods: {
    beforeQuerySearch(conditionObj) {
      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.STOCK_LOCK_STATUS_LIST.bjGet(flag);
      this.$confirm(
        `${this.$t('toast.youAreTipText')} ${TEXT} ${row.warehouseName}${this.$t(
          'BusinessStockChange.confirmText2',
        )}，${this.$t('toast.continueTipText')}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.operationApi({
            id: row.id,
            status: flag,
          });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$toPage('BusinessStockLockAdd');
    },
    /** 编辑操作 */
    onEdit(row) {
    },
    /** 查看 */
    onView(row) {
      this.$toPage('BusinessStockLockView', { id: row.id });
    },
    operationApi(API_DATA) {
      stockApi.statusReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      stockApi.detailReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 获取仓库列表
    // getList() {
    //   commonApi
    //     .getListWarehouses({
    //       code: null,
    //       name: null,
    //       typeCode: null,
    //       status: 1,
    //     })
    //     .then(res => {
    //       res.forEach((item) => {
    //         this.WarehousesList.push({label: item.name, value: item.typeCode});
    //       });
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
.el-tag {
  margin-right: 10px;
}
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
